// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cds-privacy-policy{font-size:.9em}.cds-privacy-policy__close{display:inline-flex;justify-content:flex-end;margin:0 0 0 auto}.cds-privacy-policy__close-icon{margin-top:.25em;margin-right:.25em}#cds-privacy-policy.cds-privacy-policy__dialog .cds-privacy-policy__text{margin:0;padding-top:0}.cds-privacy-policy__link{font-weight:400}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
